import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {Component, ElementRef, Inject} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PageComponent } from '@shared/lib/components/page.component';
import { FloatingPresence } from '@shared/lib/model/floating-presence';
import { AuthService } from '@shared/lib/services/auth.service';
import { DataService } from '@shared/lib/services/data.service';
import { FloatingPresenceService } from '@shared/lib/services/floating-presence.service';
import { LocaleService } from '@shared/lib/services/locale.service';
import { PageStructureService } from '@shared/lib/services/page-structure.service';
import { TranslationMapperService } from '@shared/lib/services/translation-mapper.service';
import { UrlService } from '@shared/lib/services/url.service';
import { DEFAULT_LOCALE } from '@shared/lib/shared.tokens';
import { UsanaMarketService } from '@usana/ux/markets';
import { Observable } from 'rxjs';

@Component({
  selector: 'u-opportunity',
  templateUrl: './opportunity.component.html',
  styleUrls: ['./opportunity.component.scss']
})
export class OpportunityComponent extends PageComponent {
  src = 'page-opportunity';
  floatingPresence: FloatingPresence;
  enrollmentLink: Observable<string>;

  constructor(@Inject(DEFAULT_LOCALE) protected readonly defaultLocale: string,
              protected usanaMarketService: UsanaMarketService,
              @Inject(DOCUMENT) document: Document,
              http: HttpClient,
              localeService: LocaleService,
              titleService: Title,
              metaService: Meta,
              route: ActivatedRoute,
              authService: AuthService,
              urlService: UrlService,
              translationMapperService: TranslationMapperService,
              router: Router,
              pageStructureService: PageStructureService,
              el: ElementRef,
              dataService: DataService,
              protected floatingPresenceService: FloatingPresenceService) {
    super(defaultLocale,
      usanaMarketService,
      document,
      http,
      localeService,
      titleService,
      metaService,
      route,
      authService,
      urlService,
      translationMapperService,
      router,
      pageStructureService,
      el,
      dataService);
    this.floatingPresenceService.loadFloatingPresence().then((fp: FloatingPresence) => {
      this.floatingPresence = fp;
      this.enrollmentLink = this.floatingPresenceService.getEnrollLink();
    });
  }

  showEnrollmentLink() {
    // eslint-disable-next-line
    return this.presenceIsLoaded() && this.floatingPresence.params['join'].value === 'true';
  }

  private presenceIsLoaded(): boolean {
    return !!this.floatingPresence && !!this.floatingPresence.websiteId;
  }

  get inShareTableMarket() {
    return this.marketIn('enu-IN,enu-US,zhs-US,zht-US,spa-US,spa-MX,fre-CA,zhs-CA,zht-CA,enu-CA');
  }
}
